import React, { useState } from "react"
import { ButtonHLPure, DialogSystemGLPure, Label, SimpleLoading, TextAreaHLPure } from "../../pures"
import "./contractors-catalog-disable.view.css"
import LabelPure from "../../pures/label/label.pure"
import { useTranslation } from "react-i18next";
import { ContractorService } from "../../../services";

const ContractorsCatalogDisable = (props) => {
    let {
        url,
        token,
        nameComponentUser,
        isLoadingView,
        showLoadingRequesting,
        showCompletedRequesting,
        showErrorRequesting,
        toggleLoadingRequesting,
        toggleErrorRequesting,
        toggleCompletedRequesting,
        toggleLoadingScreen,
        messageError,
        sendOtherPage,
        backGridView,
        dateModified,
        contractorGridSelected,
        paramsId,
        getConractorsForService
    } = props

    const { t } = useTranslation();

    const [disableDescription, setDisableDescription] = useState('')

    const contractorService = new ContractorService(url)

    let labelBtn = (contractorGridSelected.status) ? t("contractorsCatalogDisable-btn-disable") : t("contractorsCatalogDisable-btn-enable")
    let labelTextArea = (contractorGridSelected.status) ? t("contractorsCatalogDisable.reasons.text.area.disable") : t("contractorsCatalogDisable.reasons.text.area.enable")
    let labelReasons = (contractorGridSelected && contractorGridSelected.desactivationReason) ? contractorGridSelected.desactivationReason : ''

    const handleChangeTextArea = (e) => {
        setDisableDescription(e.target.value)
    }

    const handleDisableContractor = async () => {
        toggleLoadingRequesting(true)
        let errorMessage = `Ocurrió un error al ${labelBtn} el contratante`
        let active = !contractorGridSelected.status
        try {
            let solicitudId = `${contractorGridSelected.id}`
            let disableContractor = await contractorService.updateContractor(contractorGridSelected.id, null, null, null, null, null, null, null, null, null, null, null, solicitudId, token, active, disableDescription)
            if (disableContractor && disableContractor.data && disableContractor.data.data && Number(disableContractor.data.statusCode) === 200) {
                getConractorsForService(backGridView)
            } else {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, errorMessage, 4000, false)
            }
        } catch (error) {
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true, errorMessage, 4000, false)
        }
    }


    return (
        <div className="contractorsCatalogDisable-container">
            {isLoadingView ? (
                <SimpleLoading />
            ) : (
                <div className="contractorsCatalogDisable-body">
                    {showLoadingRequesting ? (<DialogSystemGLPure toggleLoadingRequesting={toggleLoadingRequesting} showLoadingRequesting={showLoadingRequesting} />) : null}
                    {showCompletedRequesting ? (<DialogSystemGLPure showCompletedRequesting={showCompletedRequesting} toggleCompletedRequesting={toggleCompletedRequesting} />) : null}
                    {showErrorRequesting ? (<DialogSystemGLPure toggleErrorRequesting={toggleErrorRequesting} message={messageError} showErrorRequesting={showErrorRequesting} />) : null}
                    <div className="contractorsCatalogDisable-subtitle">
                        <h1>{contractorGridSelected.name}</h1>
                    </div>
                    {
                        (contractorGridSelected && contractorGridSelected.desactivationReason) ? (
                            <>
                                <div className="contractorsCatalogDisable-container-reasons-title">
                                    <h1>{t("contractorsCatalogDisable.reasons")}</h1>
                                </div>
                                <div className="contractorsCatalogDisable-container-reasons-label">
                                    <p>{labelReasons}</p>
                                </div>
                            </>
                        ) : null
                    }

                    <div className="contractorsCatalogDisable-container-text-area">
                        <TextAreaHLPure
                            labelTextArea={labelTextArea}
                            valueTextData={disableDescription}
                            handleChangeTextArea={handleChangeTextArea}
                        />
                    </div>
                    <div className="contractorsCatalogDisable-container-btns">
                        <div className="contractorsCatalogDisable-btn-exit">
                            <ButtonHLPure
                                nameBtn={t("followUpActionsContractsView.button.exit")}
                                primary={false}
                                onClickBtn={backGridView}
                            />
                        </div>
                        <ButtonHLPure
                            nameBtn={labelBtn}
                            primary={true}
                            onClickBtn={handleDisableContractor}
                        />
                    </div>
                </div>
            )
            }
        </div>
    )
}

export default ContractorsCatalogDisable